import { render, staticRenderFns } from "./y_search.vue?vue&type=template&id=2f60eade&"
import script from "./y_search.vue?vue&type=script&lang=js&"
export * from "./y_search.vue?vue&type=script&lang=js&"
import style0 from "./y_search.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports